export default defineNuxtPlugin({
  name: 'newLevelModal',
  parallel: true,
  order: 2,
  setup: () => {
    const route = useRoute()
    const router = useRouter()
    const io = useSocket()
    const newVipLevel = useState('newVipLevel', () => null)

    io.on('userNotification', async (payload) => {
      if (payload.type !== 'carrotVipClubLevelChanged') return
      if (route.path.includes('/casino/games')) return
      newVipLevel.value = payload.data
      router.push({
        path: route.path,
        query: { modal: 'newVipLevel', ...route.query },
      })
    })
  },
})
